// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cxb7","content":"styles_content__1aisf"};